import React, { useEffect, useState } from 'react';
// javascipt plugin for creating charts
import {
  Chart,
  Title,
  Tooltip,
  CategoryScale,
  LinearScale,
  BarElement,
} from 'chart.js';
// react plugin used to create charts
import { Bar } from 'react-chartjs-2';
// reactstrap components
import { round } from 'lodash-es';
import { parseOptions } from 'variables/charts';
import { chartOptions } from 'variables/charts';
// import { isFloat } from '../../../../utils/misc';
import { Card, CardBody, Spinner } from 'reactstrap';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { useChargerwiseAnalyticsOfCorporate } from 'utils/queries/corporateAnalytics';
import { orderBy } from 'lodash';
parseOptions(Chart, chartOptions());
Chart.plugins.register(
  ChartDataLabels,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
);

export default function DashboardEnergyConsumedChart({ selectedYear }) {
  const {
    data: dailyData,
    isLoading,
    error,
  } = useChargerwiseAnalyticsOfCorporate(selectedYear);

  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (dailyData?.data?.length > 0) {
      const sortedData = orderBy(dailyData?.data, ['KWH_DELIVERED'], ['desc']);
      const data = {
        labels: sortedData?.map((row, indx) => `${row?.CPID}`), //['a', 'b', 'c', 'd', 'e', 'f'], //
        datasets: [
          {
            label: '',
            data: sortedData?.map((row) => row?.KWH_DELIVERED),
            backgroundColor: '#1a7bbb', //'rgba(255, 99, 132, 0.5)',
            color: '#ffffff',
            barThickness: 20,
            datalabels: {
              display: true,
              formatter: (value) => `${round(value, 2)} kWh`,
              color: 'black',
              anchor: 'end',
              offset: -20,
              align: 'start',
            },
          },
        ],
      };

      setChartData(data);
    }
  }, [dailyData]);

  if (isLoading) {
    <h1>Loading</h1>;
  }
  if (error) {
    <h1>Error</h1>;
  }

  const options = {
    title: {
      display: true,
      text: `Energy Consumed ${selectedYear}`,
      color: '#414141',
      position: 'bottom',
    },
    scales: {
      xAxes: {
        grid: {
          display: true,
        },
        ticks: {
          beginAtZero: true,
        },
      },
      yAxes: [
        {
          ticks: {
            display: false,
          },
        },
      ],

      // y: {
      //   display: false,
      //   grid: {
      //     display: false,
      //   },
      //   title: {
      //     display: false,
      //     text: 'Energy',
      //   },
      //   ticks: {
      //     display: false,
      //     color: '#000000',
      //     stepSize: 200,
      //   },
      // },
    },
    layout: {
      padding: {
        top: 15,
        left: 0,
        right: 0,
        bottom: 0,
      },
    },
    tooltips: {
      enabled: false,
    },
  };
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: '2px solid rgb(222, 222, 225)',
          borderRadius: '10px',
          boxShadow: 'rgb(222 222 225) 5px 5px',
        }}
      >
        {isLoading ? (
          <Spinner style={{ color: '#2675b8' }} />
        ) : error ? (
          'Oops something went wrong'
        ) : dailyData?.data?.lemgth === 0 ? (
          'We dont have any Analytics report'
        ) : (
          <Card style={{ width: '100%', height: '100%' }}>
            <CardBody>
              <div
                style={{
                  maxHeight: '250px',
                  minHeight: '250px',
                }}
              >
                <Bar options={options} data={chartData} />
              </div>
            </CardBody>
          </Card>
        )}
      </div>
    </>
  );
}
